/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getTest, getTestExecution, listTests } from "../graphql/queries";
import { updateTestExecution } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function TestExecutionUpdateForm(props) {
  const {
    id: idProp,
    testExecution: testExecutionModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    score: "",
    dateTimeStarted: "",
    answers: [],
    TestExecutionStatus: "",
    dateTimeFinished: "",
    durationMinutes: "",
    studentId: "",
    testID: undefined,
  };
  const [score, setScore] = React.useState(initialValues.score);
  const [dateTimeStarted, setDateTimeStarted] = React.useState(
    initialValues.dateTimeStarted
  );
  const [answers, setAnswers] = React.useState(initialValues.answers);
  const [TestExecutionStatus, setTestExecutionStatus] = React.useState(
    initialValues.TestExecutionStatus
  );
  const [dateTimeFinished, setDateTimeFinished] = React.useState(
    initialValues.dateTimeFinished
  );
  const [durationMinutes, setDurationMinutes] = React.useState(
    initialValues.durationMinutes
  );
  const [studentId, setStudentId] = React.useState(initialValues.studentId);
  const [testID, setTestID] = React.useState(initialValues.testID);
  const [testIDLoading, setTestIDLoading] = React.useState(false);
  const [testIDRecords, setTestIDRecords] = React.useState([]);
  const [selectedTestIDRecords, setSelectedTestIDRecords] = React.useState([]);
  const autocompleteLength = 10;
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = testExecutionRecord
      ? { ...initialValues, ...testExecutionRecord, testID }
      : initialValues;
    setScore(cleanValues.score);
    setDateTimeStarted(cleanValues.dateTimeStarted);
    setAnswers(cleanValues.answers ?? []);
    setCurrentAnswersValue("");
    setTestExecutionStatus(cleanValues.TestExecutionStatus);
    setDateTimeFinished(cleanValues.dateTimeFinished);
    setDurationMinutes(cleanValues.durationMinutes);
    setStudentId(cleanValues.studentId);
    setTestID(cleanValues.testID);
    setCurrentTestIDValue(undefined);
    setCurrentTestIDDisplayValue("");
    setErrors({});
  };
  const [testExecutionRecord, setTestExecutionRecord] = React.useState(
    testExecutionModelProp
  );
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getTestExecution.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getTestExecution
        : testExecutionModelProp;
      const testIDRecord = record ? record.testID : undefined;
      const testRecord = testIDRecord
        ? (
            await client.graphql({
              query: getTest.replaceAll("__typename", ""),
              variables: { id: testIDRecord },
            })
          )?.data?.getTest
        : undefined;
      setTestID(testIDRecord);
      setSelectedTestIDRecords([testRecord]);
      setTestExecutionRecord(record);
    };
    queryData();
  }, [idProp, testExecutionModelProp]);
  React.useEffect(resetStateValues, [testExecutionRecord, testID]);
  const [currentAnswersValue, setCurrentAnswersValue] = React.useState("");
  const answersRef = React.createRef();
  const [currentTestIDDisplayValue, setCurrentTestIDDisplayValue] =
    React.useState("");
  const [currentTestIDValue, setCurrentTestIDValue] = React.useState(undefined);
  const testIDRef = React.createRef();
  const getDisplayValue = {
    testID: (r) => `${r?.Topic ? r?.Topic + " - " : ""}${r?.id}`,
  };
  const validations = {
    score: [],
    dateTimeStarted: [],
    answers: [],
    TestExecutionStatus: [],
    dateTimeFinished: [],
    durationMinutes: [],
    studentId: [],
    testID: [{ type: "Required" }],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const convertToLocal = (date) => {
    const df = new Intl.DateTimeFormat("default", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      calendar: "iso8601",
      numberingSystem: "latn",
      hourCycle: "h23",
    });
    const parts = df.formatToParts(date).reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
  };
  const fetchTestIDRecords = async (value) => {
    setTestIDLoading(true);
    const newOptions = [];
    let newNext = "";
    while (newOptions.length < autocompleteLength && newNext != null) {
      const variables = {
        limit: autocompleteLength * 5,
        filter: {
          or: [{ Topic: { contains: value } }, { id: { contains: value } }],
        },
      };
      if (newNext) {
        variables["nextToken"] = newNext;
      }
      const result = (
        await client.graphql({
          query: listTests.replaceAll("__typename", ""),
          variables,
        })
      )?.data?.listTests?.items;
      var loaded = result.filter((item) => testID !== item.id);
      newOptions.push(...loaded);
      newNext = result.nextToken;
    }
    setTestIDRecords(newOptions.slice(0, autocompleteLength));
    setTestIDLoading(false);
  };
  React.useEffect(() => {
    fetchTestIDRecords("");
  }, []);
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          score: score ?? null,
          dateTimeStarted: dateTimeStarted ?? null,
          answers: answers ?? null,
          TestExecutionStatus: TestExecutionStatus ?? null,
          dateTimeFinished: dateTimeFinished ?? null,
          durationMinutes: durationMinutes ?? null,
          studentId: studentId ?? null,
          testID,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateTestExecution.replaceAll("__typename", ""),
            variables: {
              input: {
                id: testExecutionRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "TestExecutionUpdateForm")}
      {...rest}
    >
      <TextField
        label="Score"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={score}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              score: value,
              dateTimeStarted,
              answers,
              TestExecutionStatus,
              dateTimeFinished,
              durationMinutes,
              studentId,
              testID,
            };
            const result = onChange(modelFields);
            value = result?.score ?? value;
          }
          if (errors.score?.hasError) {
            runValidationTasks("score", value);
          }
          setScore(value);
        }}
        onBlur={() => runValidationTasks("score", score)}
        errorMessage={errors.score?.errorMessage}
        hasError={errors.score?.hasError}
        {...getOverrideProps(overrides, "score")}
      ></TextField>
      <TextField
        label="Date time started"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={dateTimeStarted && convertToLocal(new Date(dateTimeStarted))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted: value,
              answers,
              TestExecutionStatus,
              dateTimeFinished,
              durationMinutes,
              studentId,
              testID,
            };
            const result = onChange(modelFields);
            value = result?.dateTimeStarted ?? value;
          }
          if (errors.dateTimeStarted?.hasError) {
            runValidationTasks("dateTimeStarted", value);
          }
          setDateTimeStarted(value);
        }}
        onBlur={() => runValidationTasks("dateTimeStarted", dateTimeStarted)}
        errorMessage={errors.dateTimeStarted?.errorMessage}
        hasError={errors.dateTimeStarted?.hasError}
        {...getOverrideProps(overrides, "dateTimeStarted")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted,
              answers: values,
              TestExecutionStatus,
              dateTimeFinished,
              durationMinutes,
              studentId,
              testID,
            };
            const result = onChange(modelFields);
            values = result?.answers ?? values;
          }
          setAnswers(values);
          setCurrentAnswersValue("");
        }}
        currentFieldValue={currentAnswersValue}
        label={"Answers"}
        items={answers}
        hasError={errors?.answers?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("answers", currentAnswersValue)
        }
        errorMessage={errors?.answers?.errorMessage}
        setFieldValue={setCurrentAnswersValue}
        inputFieldRef={answersRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Answers"
          isRequired={false}
          isReadOnly={false}
          value={currentAnswersValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.answers?.hasError) {
              runValidationTasks("answers", value);
            }
            setCurrentAnswersValue(value);
          }}
          onBlur={() => runValidationTasks("answers", currentAnswersValue)}
          errorMessage={errors.answers?.errorMessage}
          hasError={errors.answers?.hasError}
          ref={answersRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "answers")}
        ></TextField>
      </ArrayField>
      <SelectField
        label="Test execution status"
        placeholder="Please select an option"
        isDisabled={false}
        value={TestExecutionStatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted,
              answers,
              TestExecutionStatus: value,
              dateTimeFinished,
              durationMinutes,
              studentId,
              testID,
            };
            const result = onChange(modelFields);
            value = result?.TestExecutionStatus ?? value;
          }
          if (errors.TestExecutionStatus?.hasError) {
            runValidationTasks("TestExecutionStatus", value);
          }
          setTestExecutionStatus(value);
        }}
        onBlur={() =>
          runValidationTasks("TestExecutionStatus", TestExecutionStatus)
        }
        errorMessage={errors.TestExecutionStatus?.errorMessage}
        hasError={errors.TestExecutionStatus?.hasError}
        {...getOverrideProps(overrides, "TestExecutionStatus")}
      >
        <option
          children="Scheduled"
          value="SCHEDULED"
          {...getOverrideProps(overrides, "TestExecutionStatusoption0")}
        ></option>
        <option
          children="Started"
          value="STARTED"
          {...getOverrideProps(overrides, "TestExecutionStatusoption1")}
        ></option>
        <option
          children="Stoped"
          value="STOPED"
          {...getOverrideProps(overrides, "TestExecutionStatusoption2")}
        ></option>
        <option
          children="Submitted"
          value="SUBMITTED"
          {...getOverrideProps(overrides, "TestExecutionStatusoption3")}
        ></option>
      </SelectField>
      <TextField
        label="Date time finished"
        isRequired={false}
        isReadOnly={false}
        type="datetime-local"
        value={dateTimeFinished && convertToLocal(new Date(dateTimeFinished))}
        onChange={(e) => {
          let value =
            e.target.value === "" ? "" : new Date(e.target.value).toISOString();
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted,
              answers,
              TestExecutionStatus,
              dateTimeFinished: value,
              durationMinutes,
              studentId,
              testID,
            };
            const result = onChange(modelFields);
            value = result?.dateTimeFinished ?? value;
          }
          if (errors.dateTimeFinished?.hasError) {
            runValidationTasks("dateTimeFinished", value);
          }
          setDateTimeFinished(value);
        }}
        onBlur={() => runValidationTasks("dateTimeFinished", dateTimeFinished)}
        errorMessage={errors.dateTimeFinished?.errorMessage}
        hasError={errors.dateTimeFinished?.hasError}
        {...getOverrideProps(overrides, "dateTimeFinished")}
      ></TextField>
      <TextField
        label="Duration minutes"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={durationMinutes}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted,
              answers,
              TestExecutionStatus,
              dateTimeFinished,
              durationMinutes: value,
              studentId,
              testID,
            };
            const result = onChange(modelFields);
            value = result?.durationMinutes ?? value;
          }
          if (errors.durationMinutes?.hasError) {
            runValidationTasks("durationMinutes", value);
          }
          setDurationMinutes(value);
        }}
        onBlur={() => runValidationTasks("durationMinutes", durationMinutes)}
        errorMessage={errors.durationMinutes?.errorMessage}
        hasError={errors.durationMinutes?.hasError}
        {...getOverrideProps(overrides, "durationMinutes")}
      ></TextField>
      <TextField
        label="Student id"
        isRequired={false}
        isReadOnly={false}
        value={studentId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted,
              answers,
              TestExecutionStatus,
              dateTimeFinished,
              durationMinutes,
              studentId: value,
              testID,
            };
            const result = onChange(modelFields);
            value = result?.studentId ?? value;
          }
          if (errors.studentId?.hasError) {
            runValidationTasks("studentId", value);
          }
          setStudentId(value);
        }}
        onBlur={() => runValidationTasks("studentId", studentId)}
        errorMessage={errors.studentId?.errorMessage}
        hasError={errors.studentId?.hasError}
        {...getOverrideProps(overrides, "studentId")}
      ></TextField>
      <ArrayField
        lengthLimit={1}
        onChange={async (items) => {
          let value = items[0];
          if (onChange) {
            const modelFields = {
              score,
              dateTimeStarted,
              answers,
              TestExecutionStatus,
              dateTimeFinished,
              durationMinutes,
              studentId,
              testID: value,
            };
            const result = onChange(modelFields);
            value = result?.testID ?? value;
          }
          setTestID(value);
          setCurrentTestIDValue(undefined);
        }}
        currentFieldValue={currentTestIDValue}
        label={"Test id"}
        items={testID ? [testID] : []}
        hasError={errors?.testID?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("testID", currentTestIDValue)
        }
        errorMessage={errors?.testID?.errorMessage}
        getBadgeText={(value) =>
          value
            ? getDisplayValue.testID(
                testIDRecords.find((r) => r.id === value) ??
                  selectedTestIDRecords.find((r) => r.id === value)
              )
            : ""
        }
        setFieldValue={(value) => {
          setCurrentTestIDDisplayValue(
            value
              ? getDisplayValue.testID(
                  testIDRecords.find((r) => r.id === value) ??
                    selectedTestIDRecords.find((r) => r.id === value)
                )
              : ""
          );
          setCurrentTestIDValue(value);
          const selectedRecord = testIDRecords.find((r) => r.id === value);
          if (selectedRecord) {
            setSelectedTestIDRecords([selectedRecord]);
          }
        }}
        inputFieldRef={testIDRef}
        defaultFieldValue={""}
      >
        <Autocomplete
          label="Test id"
          isRequired={true}
          isReadOnly={false}
          placeholder="Search Test"
          value={currentTestIDDisplayValue}
          options={testIDRecords
            .filter(
              (r, i, arr) =>
                arr.findIndex((member) => member?.id === r?.id) === i
            )
            .map((r) => ({
              id: r?.id,
              label: getDisplayValue.testID?.(r),
            }))}
          isLoading={testIDLoading}
          onSelect={({ id, label }) => {
            setCurrentTestIDValue(id);
            setCurrentTestIDDisplayValue(label);
            runValidationTasks("testID", label);
          }}
          onClear={() => {
            setCurrentTestIDDisplayValue("");
          }}
          defaultValue={testID}
          onChange={(e) => {
            let { value } = e.target;
            fetchTestIDRecords(value);
            if (errors.testID?.hasError) {
              runValidationTasks("testID", value);
            }
            setCurrentTestIDDisplayValue(value);
            setCurrentTestIDValue(undefined);
          }}
          onBlur={() => runValidationTasks("testID", currentTestIDValue)}
          errorMessage={errors.testID?.errorMessage}
          hasError={errors.testID?.hasError}
          ref={testIDRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "testID")}
        ></Autocomplete>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || testExecutionModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || testExecutionModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
